import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import SingleBeltInfoMobile from '../../../pages/Mobile/Belts/SingleBeltInfoMobile';
import BeltHallOfFame from '../../../pages/BeltHallOfFame';

const SingleBeltResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <SingleBeltInfoMobile /> : <BeltHallOfFame />;
};

export default SingleBeltResponsive;